import { c as _c } from "react/compiler-runtime";
import { throttle } from 'es-toolkit';
import { useLayoutEffect } from 'react';
export const useGlobalEventListener = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useLayoutEffect(_temp2, t0);
};
function _temp() {
  const height = window.visualViewport?.height || window.innerHeight;
  document.documentElement.style.setProperty("--viewport-height", `${height}px`);
}
function _temp2() {
  const updateHeight = _temp;
  updateHeight();
  const throttledUpdateHeight = throttle(updateHeight, 100);
  window.addEventListener("resize", throttledUpdateHeight);
  window.addEventListener("scroll", throttledUpdateHeight);
  window.visualViewport?.addEventListener("resize", throttledUpdateHeight);
  return () => {
    window.removeEventListener("resize", throttledUpdateHeight);
    window.removeEventListener("scroll", throttledUpdateHeight);
    window.visualViewport?.removeEventListener("resize", throttledUpdateHeight);
    throttledUpdateHeight.cancel();
  };
}